<template>
	<section class="page page-onboarding">
		<SceneOnboarding />
	</section>
</template>

<script lang="ts">
	import PageBase from '@/Core/Page.vue';
	import { Component } from 'vue-property-decorator';

	/**
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package Page
	 * @project ChalkySticks App
	 */
	@Component
	export default class PageOnboarding extends PageBase {
		// Not implemented
	}
</script>

<style lang="scss">
	[page='PageOnboarding'] #GlobalHeader,
	[page='PageOnboarding'] #GlobalNavigationTabs,
	[page='PageOnboarding'] .newfeature-coach-marks {
		display: none;
	}

	#app .page-onboarding {
		bottom: 0;
	}
</style>
